import React from "react"
import styled from "styled-components"

import TimeSelect from "../../common/components/TimeSelect"

import { colors } from "buoy-theme"
import { Paragraph, Button } from "buoy-core"
import Check from "../../completion/images/Check"
import smoothscroll from "smoothscroll-polyfill"
import { FormattedMessage } from "react-intl"

const TimeContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 28px;
`

const ButtonClarifier = styled(Button)`
  min-width: unset;
  max-width: 100%;
  text-align: left;
`

export const QuestionContainer = styled.section`
  border-bottom: solid 1px ${colors.neutralLighter};
  padding: 12px 0;

  &:last-of-type {
    border: none;
    padding: 12px 0 0;
  }
`

const scrollQuestionContainer = index => {
  let questions = []
  // get all question containers that will need to be scrolled down
  for (let i = 0; i < index; i++) {
    questions.push(document.getElementById("question-container-" + i))
  }
  let chatWindow = document.getElementById("chatWindow")
  let filterCard = document.getElementById("filter-card")
  let filterHeader = document.getElementById("filter-card-header")
  if (questions.every(elt => elt) && chatWindow && filterCard && filterHeader) {
    chatWindow = window.getComputedStyle(chatWindow)
    filterHeader = filterHeader.scrollHeight
    filterCard = filterCard.scrollHeight
    if (questions.length > 0)
      questions = questions
        .map(elt => (elt = elt.scrollHeight))
        .reduce((x, y) => x + y)
    else {
      //first question, want to display the header too
      questions = -filterHeader
    }

    // get chatWindow height without padding
    chatWindow = parseInt(chatWindow.getPropertyValue("height"))
    smoothscroll.polyfill()
    setTimeout(() => {
      const val = chatWindow - filterCard - filterHeader + questions
      window.scrollTo({ top: val, behavior: "smooth" })
    }, 100)
  }
}

const bindValue = (func, item) => e => func(e, item)

const answerState = (item, onResponse, props) => {
  if (props.current && item.index === props.current.index) {
    // scroll to the current question container
    scrollQuestionContainer(props.index)
  }

  if (props.current && item.index > props.current.index) {
    // We haven't answered this question yet.
    return null
  }

  if (item.duration) {
    // The question is a duration question and has not been answered.
    return (
      <TimeContainer className="clarifier-container">
        <TimeSelect
          duration={item.duration}
          onDurationChange={bindValue(props.onDurationChange, item)}
          onUnitChange={bindValue(props.onUnitChange, item.index)}
        />
        {item.response.length < 1 && (
          <Button margin="6px 0 0" onClick={() => onResponse(item.options[0])}>
            <FormattedMessage id="duration.submit" defaultMessage="Submit"/>
          </Button>
        )}
      </TimeContainer>
    )
  }

  // The question is a single-response question and has not been answered.
  return (
    <OptionContainer className="clarifier-container">
      {item.options.map((opt, i) => (
        <ButtonContainer key={i}>
          <ButtonClarifier
            margin="6px 0"
            selected={
              item.response.filter(x => x.token === opt.token).length > 0
            }
            onClick={() => onResponse(opt)}
          >
            {opt.text}
          </ButtonClarifier>
          {item.response.filter(x => x.token === opt.token).length > 0 && (
            <Check
              margin="0 0 0 10px"
              color="primary"
              width="18px"
              strokeWidth="1.5"
              height="14px"
            />
          )}
        </ButtonContainer>
      ))}
    </OptionContainer>
  )
}

const getQuestionColor = (props, item) =>
  props.current && item.index > props.current.index
    ? "neutral"
    : "neutralDarkest"

const Question = ({ item, last, onResponse, ...props }) => (
  <QuestionContainer id={"question-container-" + props.index}>
    <Paragraph color={getQuestionColor(props, item)} margin="6px 0">
      {item.text}
    </Paragraph>
    {answerState(item, onResponse, props)}
  </QuestionContainer>
)

export { Question as default }



// WEBPACK FOOTER //
// ./assets/filters/components/Question.js